// API-related constants for use throughout the app

export const API_STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes 